const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

import { axiosInstance as axios } from '../../utils/axios';

import { PAGINATION_PAGE_SIZE } from '../../config-global';

{
  /*** GET FAMILY  ****/
}
export const getFamilies = createAsyncThunk('get/family', async () => {
  try {
    const params = {
      'pagination[pageSize]': 200,
    };
    const response = await axios.get('/api/familias-profissionais', { params });
    return response.data;
  } catch (error) {}
});

{
  /*** GET LEVEL  ****/
}
export const getLevel = createAsyncThunk('get/level', async () => {
  try {
    const params = {
      'pagination[pageSize]': 200,
    };
    const response = await axios.get('/api/nivel-formacaos', { params });
    return response.data;
  } catch (error) {}
});

{
  /** GET QUALIFICATIONS  ****/
}

export const getQualification = createAsyncThunk('get/qualification', async (prms) => {
  try {
    const params = {
      'pagination[pageSize]': Number(PAGINATION_PAGE_SIZE ?? 15),
      'pagination[page]': Number(prms?.page ?? 1),
      'populate[0]': 'familia_profissional',
      'populate[1]': 'programas_formativos.anexo',
      'populate[2]': 'nivel_de_qualificacao',
      'filters[titulo][$containsi]': prms?.qualification,
    };
    if (prms?.level) {
      params['filters[nivel_de_qualificacao][id][$eq]'] = Number(prms.level);
    }
    if (prms?.family) {
      params['filters[familia_profissional][id][$eq]'] = Number(prms?.family);
    }
    const response = await axios.get('/api/qualificacoes', { params });
    return response.data;
  } catch (error) {}
});

export const getQualificationById = createAsyncThunk('get/qualification/id', async (id) => {
  try {
    const response = await axios.get(`api/qualificacoes/${id}`, {
      params: {
        'populate[0]': 'familia_profissional',
        'populate[1]': 'programas_formativos.anexo',
        'populate[2]': 'unidade_de_competencia.anexo',
        'populate[3]': 'nivel_de_qualificacao',
        'populate[4]': 'perfil_profissional',
        'populate[5]': 'documentacao_geral_do_catalogo',
      },
    });
    return response.data;
  } catch (error) {}
});

const initialState = {
  family: {
    isLoading: false,
    data: [],
  },
  level: {
    isLoading: false,
    data: [],
  },
  qualifications: {
    isLoading: false,
    data: [],
  },
  qualification: {
    isLoading: false,
    data: null,
  },
};

const qualificationSlice = createSlice({
  name: 'qualification',
  initialState,
  extraReducers: {
    [getFamilies.pending]: (state) => {
      state.family.isLoading = true;
    },
    [getFamilies.fulfilled]: (state, action) => {
      state.family.isLoading = false;

      state.family.data = action.payload?.data;
    },
    [getFamilies.rejected]: (state) => {
      state.family.isLoading = false;
    },
    /*** GET LEVEL  */

    [getLevel.pending]: (state) => {
      state.level.isLoading = true;
    },
    [getLevel.fulfilled]: (state, action) => {
      state.level.isLoading = false;

      state.level.data = action.payload?.data;
    },
    [getLevel.rejected]: (state) => {
      state.level.isLoading = false;
    },

    /** GET ALL QUALIFICATION */
    [getQualification.pending]: (state) => {
      state.qualifications.isLoading = true;
    },
    [getQualification.fulfilled]: (state, action) => {
      state.qualifications.isLoading = false;

      state.qualifications.data = action.payload;
    },
    [getQualification.rejected]: (state) => {
      state.qualifications.isLoading = false;
    },

    /** GET QUALIFICATION BY ID ****/
    [getQualificationById.pending]: (state) => {
      state.qualification.isLoading = true;
    },
    [getQualificationById.fulfilled]: (state, action) => {
      state.qualification.isLoading = false;
      state.qualification.data = action.payload?.data;
    },
    [getQualificationById.rejected]: (state) => {
      state.qualification.isLoading = false;
    },
  },
});

export const qualificationReducer = qualificationSlice.reducer;

/*** Family ****** */
export const isFamilyLoading = (state) => state.qualification.family.isLoading;

export const getFamilyOptions = (state) => {
  const data = state.qualification.family.data;

  let options = [];
  if (data) {
    data.forEach((element) => {
      options.push({
        value: element.id,
        label: element.attributes.nome_da_familia,
      });
    });
  }
  return options;
};

/***** Level *******/

export const isLevelLoading = (state) => state.qualification.level.isLoading;

export const getLevelOptions = (state) => {
  const data = state.qualification.level.data;

  let options = [];
  if (data) {
    data.forEach((element) => {
      options.push({
        value: element.id,
        label: element.attributes.designacao,
      });
    });
  }
  return options;
};

/** Qualifications  *****/

export const isQualificationLoading = (state) => state.qualification.qualifications.isLoading;

export const allQualification = (state) => {
  const data = state.qualification.qualifications.data;

  let qualifications = [];

  if (data?.data) {
    data?.data?.forEach((item) => {
      let number_of_modules = item.attributes?.programas_formativos?.length;
      let duration = 0;
      if (number_of_modules > 0) {
        item.attributes?.programas_formativos.forEach((it) => {
          duration += Number(it.carga_horaria ?? 0);
        });
      }
      qualifications.push({
        id: item.id,
        title: item.attributes?.nome,
        female: item.attributes?.familia_profissional?.data?.attributes?.nome_da_familia,
        level: item.attributes?.nivel_de_qualificacao?.data?.attributes?.numero,
        modulo: number_of_modules,
        duration: duration,
        school_level: item.attributes?.pre_requesitos,
        codes: item.attributes?.codigo,
      });
    });
  }
  return {
    data: qualifications,
    meta: {
      page: data?.meta?.pagination?.page,
      totalPages: data?.meta?.pagination?.pageCount,
    },
  };
};

/**** Qualification By Id */
export const isQLoading = (state) => state.qualification.qualification.isLoading;

export const qualification = (state) => {
  const data = state.qualification.qualification.data;
  let access_to_training = [];
  let professional_profile = [];
  let training_modules = [];
  let units_skills = [];

  if (data) {
    /** Qualification data */
    let number_of_modules = data.attributes?.programas_formativos?.length;
    let duration = 0;
    if (number_of_modules > 0) {
      data.attributes?.programas_formativos.forEach((it) => {
        duration += Number(it.carga_horaria ?? 0);
      });
    }
    let qualification = {
      id: data.id,
      title: data.attributes?.nome,
      female: data.attributes?.familia_profissional?.data?.attributes?.nome_da_familia,
      description: data.attributes?.descricao,
      level: data.attributes?.nivel_de_qualificacao?.data?.attributes?.numero,
      modulo: number_of_modules,
      duration: duration,
      school_level: data.attributes?.pre_requesitos,
      codes: data.attributes?.codigo,
      access_to_training: access_to_training,
      general_document_url:
        data?.attributes?.documentacao_geral_do_catalogo?.data[0]?.attributes?.url,
    };

    /** Professional profile data  */

    if (data.attributes.perfil_profissional) {
      data.attributes.perfil_profissional.forEach((item) => {
        professional_profile.push({ id: item.id, title: item.titulo, description: item.descricao });
      });
    }

    /**Access to training */
    if (data.attributes.via_acesso) {
      data.attributes.via_acesso.forEach((item) => {
        if (item == 'FORM') {
          access_to_training.push({
            id: item,
            value: 'catalogDetailsPage.access_training',
          });
        } else if (item == 'RCVV') {
          access_to_training.push({
            id: item,
            value: 'catalogDetailsPage.access_rvcc',
          });
        }
      });
    }

    /*** Training Modules */

    if (data.attributes?.programas_formativos) {
      data.attributes.programas_formativos.forEach((item) => {
        training_modules.push({
          id: item.id,
          module: item?.titulo,
          duration: item?.carga_horaria,
          codes: item?.codigo,
          document_url: item?.anexo?.data?.attributes?.url,
        });
      });
    }

    /*** units skills ****/

    if (data?.attributes?.unidade_de_competencia) {
      data.attributes.unidade_de_competencia.forEach((item) => {
        units_skills.push({
          id: item.id,
          title: item.titulo,
          duration: item.carga_horaria,
          codes: item.codigo,
          document_url: item?.anexo?.data?.attributes.url,
        });
      });
    }
    return {
      qualification: qualification,
      professional_profile: professional_profile,
      training_modules: training_modules,

      units_skills: units_skills,
    };
  }
  return null;
};
